import { FormControlLabel, FormControlLabelProps, Radio, RadioGroup } from '@mui/material';
import * as React from "react";
import { RadioProps } from "@mui/material/Radio/Radio";

interface Props {
    id?: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    value: string;
    options: { value: any, label: any }[]
    row?: boolean;
    FormControlLabelProps?: Omit<FormControlLabelProps, "control" | "label">;
}

const LassoRadioGroup = (props: Props) => {
    return (
        <RadioGroup
            id={props?.id}
            name="radio-buttons-group"
            onChange={props.onChange}
            value={props.value}
            row={props.row}
        >
            {props.options.map(({ value, label }) =>
                <FormControlLabel
                    {...props.FormControlLabelProps}
                    key={value}
                    value={value}
                    control={<LassoRadio />}
                    label={label}
                />
            )}
        </RadioGroup>
    )
}

const LassoRadio = (props: RadioProps) =>
    <Radio
        {...props}
        size="small"
        sx={{
            py: 0
        }}
    />;

export default LassoRadioGroup;